import React from "react";
import { useParams } from "react-router-dom";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddEditUserRoleForm } from "../../components/administration";

export const AddEditRole = () => {
  const { id } = useParams();
  return (
    <PageLayout>
      {/* header section */}
      <PageHeader title={id ? "Edit User Role" : "Create User Role"} />

      {/* create user role form */}
      <AddEditUserRoleForm roleId={id} />
    </PageLayout>
  );
};
